<script>
  import { onMount } from "svelte";

  import Row from "./Row.svelte";
  import { colors } from "../utils/colors.ts";
  export let oldInput;
  export let searchField;
  export let isShowTree;
  export let tree;
  export let query;
  export let targetId;

  let _tree;
  onMount(async () => {
    _tree = tree.tree;
    isShowTree = true;
  });
</script>

<nav style="--isDisplay: {_tree ? 'block' : 'none'}; --green: {colors.green}">
  {#if _tree}
    {#each Object.keys(_tree) as unitId (unitId)}
      <Row
        bind:searchField
        bind:isShowTree
        bind:targetId
        {oldInput}
        parentToggleExpanded={() => {}}
        prevId={-1}
        tree={_tree}
        unit={_tree[unitId]}
        value={query}
      />
    {/each}
  {/if}
</nav>

<style>
  nav {
    padding-left: 3px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 600px;
    background-color: white;
    padding: 8px;
    display: var(--isDisplay);
  }
</style>
